var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiverGauge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3225_16834",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 31,
    width: 101,
    height: 95
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.6171 31.6599C75.9933 30.9527 77.0067 30.9527 77.3829 31.6599L126.381 123.78C126.735 124.446 126.252 125.25 125.498 125.25H27.5021C26.7476 125.25 26.2649 124.446 26.6192 123.78L75.6171 31.6599Z",
    fill: "#D8B4B4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3225_16834)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3225_16834)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 73,
    width: 103,
    height: 63,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73 70H63V107.682C62.3682 108.633 62 109.773 62 111C62 114.314 64.6863 117 68 117C71.3137 117 74 114.314 74 111C74 109.773 73.6318 108.633 73 107.682V70Z",
    fill: "#95AAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2523 77.75C76.1497 77.75 76.8773 77.0225 76.8773 76.125C76.8773 75.2275 76.1497 74.5 75.2523 74.5H74.4398C74.4398 70.9159 71.5239 68 67.9398 68C64.3556 68 61.4398 70.9159 61.4398 74.5V104.93C56.0691 110.621 60.1574 120 67.9403 120C75.767 120 79.7854 110.6 74.4398 104.93V104.562H75.2523C76.1497 104.562 76.8773 103.835 76.8773 102.938C76.8773 102.04 76.1497 101.312 75.2523 101.312H74.4398V98.0625H75.2523C76.1497 98.0625 76.8773 97.335 76.8773 96.4375C76.8773 95.54 76.1497 94.8125 75.2523 94.8125H74.4398V91.5625H75.2523C76.1497 91.5625 76.8773 90.835 76.8773 89.9375C76.8773 89.04 76.1497 88.3125 75.2523 88.3125H74.4398V84.25H75.2523C76.1497 84.25 76.8773 83.5225 76.8773 82.625C76.8773 81.7275 76.1497 81 75.2523 81H74.4398V77.75H75.2523ZM67.9649 116.75C64.9521 116.786 62.3163 114.315 62.2535 111.18C62.2202 109.52 62.911 107.932 64.1487 106.824C64.493 106.516 64.6899 106.075 64.6899 105.613V74.5C64.6899 72.7079 66.1478 71.25 67.9399 71.25C69.7319 71.25 71.1899 72.7079 71.1899 74.5V105.613C71.1899 106.076 71.3867 106.516 71.731 106.824C75.5836 110.273 73.1798 116.728 67.9649 116.75Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 103,
    width: 103,
    height: 52,
    fill: "#0099FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 99.8739C25 99.8739 30.8602 103.805 36.4175 102.106C41.8771 100.438 43.9008 99 49.7783 99C55.6558 99 57.2617 101.491 63.1392 102.106C69.0166 102.722 70.6225 99 76.5 99C82.3775 99 83.9834 102.106 89.8608 102.106C95.7383 102.106 97.3442 99 103.222 99C109.099 99 110.712 101.887 116.583 102.106C122.14 102.314 128 99.1286 128 99.1286V103.596C128 103.596 122.14 106.782 116.583 106.574C110.712 106.354 109.099 103.468 103.222 103.468C97.3442 103.468 95.7383 106.574 89.8608 106.574C83.9834 106.574 82.3775 103.468 76.5 103.468C70.6225 103.468 69.0166 106.574 63.1392 106.574C57.2617 106.574 55.6558 103.468 49.7783 103.468C43.9008 103.468 41.8771 104.906 36.4175 106.574C30.8602 108.273 25 104.342 25 104.342V99.8739Z",
    fill: "white"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.618 14.6507C75.9947 13.9457 77.0053 13.9457 77.382 14.6507L140.233 132.279C140.589 132.945 140.106 133.75 139.351 133.75H13.6492C12.894 133.75 12.4113 132.945 12.7672 132.279L75.618 14.6507Z",
    stroke: "#333333",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3225_16834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 97,
    fill: "white",
    transform: "translate(25 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiverGauge);
export default __webpack_public_path__ + "static/media/river_gauge.b69186b2f5d83ee0eb87e8a4190067b4.svg";
export { ForwardRef as ReactComponent };